<template>
  <div class="room-chat-bot-modal-component flex flex-col border border-gray-300">
    <div class="h-20 px-6 border-b flex justify-between items-center">
      <button class="w-6 h-6" @click="onClose">
        <img :src="require('@/assets/images/arrowBack.svg')" />
      </button>
      <div style="font-size: 28px; color: #1D242A;" class="font-bold leading-9">{{ $t("chatBot.botName") }}</div>
      <button class="w-6 h-6" @click="onClose">
        <img :src="require('@/assets/images/x_gray.svg')" />
      </button>
    </div>
    <ChatBot/>
  </div>
</template>

<script>

import BotChatList from "@/components/Room/ChatBot/BotChatList.vue";
import BotChatForm from "@/components/Room/ChatBot/BotChatForm.vue";
import ChatBot from "@/components/Room/ChatBot/ChatBot.vue";

export default {
  name: 'RoomChatBotModal',
  components: {ChatBot},
  data() {
    return {

    }
  },
  computed: {},
  methods: {
    onClose() {
      this.$modal('RoomChatBotModal')
    },
  }
}


</script>

<style lang="scss" scoped>
.room-chat-bot-modal-component {
  width: 480px;
  background-color: #fff;
  position: absolute;
  top: 50px;
  bottom: 0;
  left: 60px;
  z-index: 1;
}

.bot-chat-container {
  height: 100%;
}

.bot-chat-form {
  height: 10%
}


</style>